import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n';
import { Button } from './ui/button';

// The traced mark (atom + LDE wordmark) comes from the supplied reference and
// stays a single SVG asset. Its descriptor line sits in the same 719×222
// coordinate system but is drawn as live SVG text on top, so it can follow the
// language selected on the site and scale with the mark at every breakpoint.
export const Logo = ({ className = '' }) => {
  const { t } = useLanguage();
  const { logo } = t;
  return <span className={`brand ${className}`.trim()} role="img" aria-label={logo.alt} data-testid="brand-logo">
    <img src="/images/lde-logo-traced.svg" alt="" width="719" height="222"/>
    <svg className="brand-descriptor" viewBox="0 0 719 222" aria-hidden="true" focusable="false">
      <text className="brand-descriptor-primary" x="188" y="147" fill="#041a90" fontFamily="Arial, Helvetica, sans-serif" fontSize={logo.size} fontWeight="700" letterSpacing={logo.spacing}>{logo.line1}</text>
      <text className="brand-descriptor-since" x="188" y="180" fill="#041a90" fontFamily="Arial, Helvetica, sans-serif" fontSize={logo.size * 1.16} fontWeight="500">{logo.line2}</text>
    </svg>
  </span>;
};

export const ActionLink = ({ children, href, className = '', testId, dark = false, onClick }) => <Button asChild className={`action-link ${dark ? 'action-dark' : ''} ${className}`}><a href={href} onClick={onClick} data-testid={testId}><span>{children}</span><span className="action-arrow"><ArrowRight size={19}/></span></a></Button>;

export const MOTION_EASE = [0.22, 1, 0.36, 1];
export const MOTION_FAST = { duration: .24, ease: MOTION_EASE };
export const MOTION_STANDARD = { duration: .56, ease: MOTION_EASE };

export const Reveal = ({ children, className = '', delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div className={className} initial={reduced ? false : { opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ ...MOTION_STANDARD, delay }} {...props}>{children}</motion.div>;
};

export const Chapter = ({ children, testId }) => <div className="chapter" data-testid={testId}>{children}</div>;
